import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { CityService } from '../../services/city.service';
import { TalukhaService } from '../../services/talukha.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';

@Component({
  selector: 'app-talukha-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, JsonPipe, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent],
  templateUrl: './talukha-page.component.html',
  styleUrl: './talukha-page.component.css'
})
export class TalukhaPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Taluka';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];

  country_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'District.Division.State.country.name', headerName: 'Country', filter: true, flex: 1, },
    { field: 'District.Division.State.name', headerName: 'State', filter: true, flex: 1, },
    { field: 'District.Division.name', headerName: 'Division', filter: true, flex: 1, },
    { field: 'District.name', headerName: 'District', filter: true, flex: 1, },
    { field: 'name', headerName: 'Taluka', filter: true, flex: 1, },
    { field: 'code', headerName: 'Taluka Code', filter: true, flex: 1, },
    { headerName: "", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'link', linked_list: 'division_list', returning_key: 'id', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'link', linked_list: 'district_list', returning_key: 'id', return_as: 'district_id', sample_value: 'Thane' },
    { column_name: 'Talukha Name', type: 'text', return_as: 'name', sample_value: 'Andheri' },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'ADH' },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Disable', shortcut: 'u', color: 'gray', icon: 'bx bx-block', function: this.disable.bind(this) })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this) })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this) })
    return actions
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ts: TalukhaService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      division_id: ['', [Validators.required]],
      district_id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      code: ['', [Validators.required,Validators.minLength(2), Validators.maxLength(10),Validators.pattern('^[a-zA-Z0-9]+$')]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['country', 'state', 'division', 'distric']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ts.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async delete(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async delete_taluka() {
    try {
      let res = await this.ts.delete(this.selected_ids.id);
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');

    }
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ts.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.ts.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');

    }
  }

  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.ts.get(item.id);
      this.selected_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }

  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit_country() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      delete form_value.country_id
      delete form_value.state_id
      delete form_value.division_id
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ts.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ts.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ts, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }
}
